/**
 * 处理 uin 相关逻辑
 * 优先取 cookie 是否存在 visitor_id，如果没有，则计算出一个并存储下来
 * @Author: moonye
 * @Date: 2018-06-20 13:43:30
 * @Last Modified by: moonye
 * @Last Modified time: 2019-09-18 14:50:02
 */

import cookie from '@tencent/im-cookie';

/**
 * 获取一个随机的 uin，8 位就够了吧，要那么长干嘛
 */
function getRandomUin() {
  return ('' + Math.random()).substring(2);
}

export default function(dataFromCookie) {
  var cookieuin = dataFromCookie.ver9; // 真实 uin 数据
  var uin = cookie.realUin();
  var cookievid = dataFromCookie.visitor_id || getRandomUin();
  var ver10;
  if(cookieuin && !uin) {
    cookievid = getRandomUin();
  }
  if(uin && !cookieuin && document.referrer) {
    ver10 = 'login';
  }
  Object.assign(dataFromCookie, {
    ver9: uin ? uin : undefined, // 这里存入真实 uin 数据
    uin: cookie.uin() || '',
    visitor_id: cookievid,
    ver10: ver10
  });

  return dataFromCookie;
};